import Skeleton from 'react-loading-skeleton';

import styles from '../../AdvertisingCard.module.scss';

export interface AdvertisingCardSkeletonProps {
  style?: React.CSSProperties;
}

export const AdvertisingCardSkeleton = ({
  style,
}: AdvertisingCardSkeletonProps) => (
  <div
    className={styles.advertisingCardSkeleton}
    style={style}
    data-test-id="advertising-card-skeleton"
  >
    <Skeleton height="100%" className={styles.skeleton} />
  </div>
);
